export default {"src":"/_next/static/media/apex_logo_head.bae6d62b.svg","height":64,"width":264,"blurWidth":0,"blurHeight":0};